export default __webpack_public_path__ + "static/media/check.a1c1a027.png";